import GASv2 from './gasv2';
import GASv3 from './gasv3';
import GoogleAnalytics from './googleAnalytics';
import Optimizely from './optimizely';
import Segment from './segment';

// platforms to send to when Tracking.trackAll() is called.
export const trackAllPlatforms = [Optimizely, GoogleAnalytics, Segment];

// all supported platforms.
export {
  GASv2,
  GASv3,
  GoogleAnalytics,
  Optimizely,
  Segment,
};
